import pathToRegexp from 'path-to-regexp';
import queryString from 'query-string';

export const getPathRegex = path => {
  if (!path && path !== '') {
    // empty string is a valid path
    return [];
  }
  const regexpKeys = [];
  const re = pathToRegexp(path, regexpKeys);
  return [re, regexpKeys];
};

export const preparePathWithParams = (pathPattern, params = {}) => {
  const toPath = pathToRegexp.compile(pathPattern);
  return toPath(params);
};

export const parseQueryString = query => {
  return queryString.parse(query);
};
